class UserCalendarData {
    constructor() {
        this.id = -1;
        this.label = "";
        this.date = 1; //日期
        this.year = 1979;
        this.month = 0; //表示月份的整数值，从 0（1 月）到 11（12 月）
    }    
 }
 export default UserCalendarData